import apiCars from '../../api/apiCars'
import apiUsers from '../../api/apiUsers'
import apiProformaInvoices from "../../api/apiProformaInvoices";
import stockCars from "../../api/stockCars";

const state = {
    success: false,
    isLoading: false,
    users: [],
    managerName: null,
    userName: null,
    errors: {
        auction: [],
        brand: [],
        chassis: [],
        color: [],
        date: [],
        displacement: [],
        equipment: [],
        grade: [],
        lot: [],
        manager_id: [],
        mileage_num: [],
        model: [],
        is_usd: [],
        result: [],
        score: [],
        transmission: [],
        user_id: [],
        year: [],
    },
    newCar: {
        auction: null,
        brand: null,
        chassis: null,
        color: null,
        date: null,
        displacement: null,
        equipment: null,
        grade: null,
        lot: null,
        manager_id: null,
        mileage_num: null,
        model: null,
        is_usd: null,
        result: null,
        score: null,
        transmission: null,
        user_id: null,
        year: null
    },
    isDownloading: false,
    multiProformaErrors: {
        paymentTerm: '',
        dueDate: '',
        balanceDate: '',
        incoterm: '',
        blNumber: '',
        includes: '',
        remarks: '',
    },
    multiProformaLatest: {
        payment_term: '',
        due_date: '',
        balance_due_date: '',
        incoterm: '',
        bl_number: '',
        includes_seal: '',
        remarks: '',
    },
    multiProformaId: ''
}

const getters = {
    getNewCarErrorAuction: (state) => {
        return state.errors.auction
    },
    getNewCarErrorBrand: (state) => {
        return state.errors.brand
    },
    getNewCarErrorChassis: (state) => {
        return state.errors.chassis
    },
    getNewCarErrorColor: (state) => {
        return state.errors.color
    },
    getNewCarErrorDate: (state) => {
        return state.errors.date
    },
    getNewCarErrorDisplacement: (state) => {
        return state.errors.displacement
    },
    getNewCarErrorEquipment: (state) => {
        return state.errors.equipment
    },
    getNewCarErrorGrade: (state) => {
        return state.errors.grade
    },
    getNewCarErrorLot: (state) => {
        return state.errors.lot
    },
    getNewCarErrorManager: (state) => {
        return state.errors.manager_id
    },
    getNewCarErrorMileage: (state) => {
        return state.errors.mileage_num
    },
    getNewCarErrorModel: (state) => {
        return state.errors.model
    },
    getNewCarErrorUsd: (state) => {
        return state.errors.usd
    },
    getNewCarErrorResult: (state) => {
        return state.errors.result
    },
    getNewCarErrorScore: (state) => {
        return state.errors.score
    },
    getNewCarErrorTransmission: (state) => {
        return state.errors.transmission
    },
    getNewCarErrorUser: (state) => {
        return state.errors.user_id
    },
    getNewCarErrorYear: (state) => {
        return state.errors.year
    },
    getNewCarErrors: (state) => {
        return state.errors
    },
    getNewCar: (state) => {
        return state.newCar
    },
    getNewCarLoadingStatus: (state) => {
        return state.isLoading
    },
    getNewCarSuccessStatus: (state) => {
        return state.success
    },
    getNewCarAuction: (state) => {
        return state.newCar.auction
    },
    getNewCarBrand: (state) => {
        return state.newCar.brand
    },
    getNewCarChassis: (state) => {
        return state.newCar.chassis
    },
    getNewCarColor: (state) => {
        return state.newCar.color
    },
    getNewCarDate: (state) => {
        return state.newCar.date
    },
    getNewCarDisplacement: (state) => {
        return state.newCar.displacement
    },
    getNewCarEquipment: (state) => {
        return state.newCar.equipment
    },
    getNewCarGrade: (state) => {
        return state.newCar.grade
    },
    getNewCarLot: (state) => {
        return state.newCar.lot
    },
    getNewCarManager: (state) => {
        return state.newCar.manager_id
    },
    getNewCarManagerName: (state) => {
        return state.managerName
    },
    getNewCarMileage: (state) => {
        return state.newCar.mileage_num
    },
    getNewCarModel: (state) => {
        return state.newCar.model
    },
    getNewCarUSD: (state) => {
        return state.newCar.is_usd
    },
    getNewCarResult: (state) => {
        return state.newCar.result
    },
    getNewCarScore: (state) => {
        return state.newCar.score
    },
    getNewCarTransmission: (state) => {
        return state.newCar.transmission
    },
    getNewCarUser: (state) => {
        return state.newCar.user_id
    },
    getNewCarUserName: (state) => {
        return state.userName
    },
    getNewCarYear: (state) => {
        return state.newCar.year
    },
    getNewCarUsers: (state) => {
        return state.users
    },
    getDownloadingStatus: (state) => {
        return state.isDownloading
    },
    getMultiProformaErrors: (state) => {
        return state.multiProformaErrors
    },
    getMultiProformaLatest: (state) => {
        return state.multiProformaLatest
    },
    getMultiProformaId: (state) => {
        return state.multiProformaId
    }
}

const mutations = {
    changeNewCarErrors: (state, newValue) => {
        state.errors = newValue
    },
    changeNewCarLoadingStatus: (state, newValue) => {
        state.isLoading = newValue
    },
    changeNewCarSuccessStatus: (state, newValue) => {
        state.success = newValue
    },
    changeNewCarAuction: (state, newValue) => {
        state.newCar.auction = newValue
    },
    changeNewCarBrand: (state, newValue) => {
        state.newCar.brand = newValue
    },
    changeNewCarChassis: (state, newValue) => {
        state.newCar.chassis = newValue
    },
    changeNewCarColor: (state, newValue) => {
        state.newCar.color = newValue
    },
    changeNewCarDate: (state, newValue) => {
        state.newCar.date = newValue
    },
    changeNewCarDisplacement: (state, newValue) => {
        state.newCar.displacement = newValue
    },
    changeNewCarEquipment: (state, newValue) => {
        state.newCar.equipment = newValue
    },
    changeNewCarGrade: (state, newValue) => {
        state.newCar.grade = newValue
    },
    changeNewCarLot: (state, newValue) => {
        state.newCar.lot = newValue
    },
    changeNewCarManager: (state, newValue) => {
        state.newCar.manager_id = newValue
    },
    changeNewCarManagerName: (state, newValue) => {
        state.managerName = newValue
    },
    changeNewCarMileage: (state, newValue) => {
        state.newCar.mileage_num = newValue
    },
    changeNewCarModel: (state, newValue) => {
        state.newCar.model = newValue
    },
    changeNewCarUsd: (state, newValue) => {
        state.newCar.is_usd = newValue
    },
    changeNewCarResult: (state, newValue) => {
        state.newCar.result = newValue
    },
    changeNewCarScore: (state, newValue) => {
        state.newCar.score = newValue
    },
    changeNewCarTransmission: (state, newValue) => {
        state.newCar.transmission = newValue
    },
    changeNewCarUser: (state, newValue) => {
        state.newCar.user_id = newValue
    },
    changeNewCarUserName: (state, newValue) => {
        state.userName = newValue
    },
    changeNewCarYear: (state, newValue) => {
        state.newCar.year = newValue
    },
    changeNewCarUsers: (state, newValue) => {
        state.users = newValue
    },
    changeNewCarToDefault: (state) => {
        const defaultNewCar = {
            user_id: null,
            manager_id: null,
            auction: null,
            brand: null,
            chassis: null,
            color: null,
            date: null,
            displacement: null,
            equipment: null,
            grade: null,
            lot: null,
            mileage_num: null,
            model: null,
            is_usd: null,
            result: null,
            score: null,
            transmission: null,
            year: null,
        }

        state.newCar = Object.assign({}, defaultNewCar)
    },
    changeNewCarErrorsToDefault: (state) => {
        const defaultNewCarErrors = {
            user_id: [],
            manager_id: [],
            auction: [],
            brand: [],
            chassis: [],
            color: [],
            date: [],
            displacement: [],
            equipment: [],
            grade: [],
            lot: [],
            mileage_num: [],
            model: [],
            is_usd: [],
            result: [],
            score: [],
            transmission: [],
            year: [],
        }

        state.errors = Object.assign({}, defaultNewCarErrors)
    },
    setDownloadStatus: (state, status) => {
        state.isDownloading = status
    },
    setErrors: (state, status) => {
        Object.keys(status).forEach(function (key) {
            state.multiProformaErrors[key] = status[key]
        })
        //state.multiProformaErrors = status
    },
    setMultiProformaLatest: (state, data) => {
        state.multiProformaLatest = data
    },
    updateMultiProformaLatest: (state, data) => {
        Object.keys(data).forEach(function (key) {
            state.multiProformaLatest[key] = data[key]
        })
    },
    setMultiProformaId: (state, id) => {
        state.multiProformaId = id
    }
}

const actions = {
    createNewCar: function (context) {
        context.commit('changeNewCarErrorsToDefault')
        context.commit('changeNewCarLoadingStatus', true)
        apiCars
            .createNewCarRequest(context.getters.getNewCar)
            .then((response) => {
                context.commit('changeNewCarLoadingStatus', false)
                context.commit('changeNewCarSuccessStatus', true)
                context.commit('changeNewCarToDefault')
                setTimeout(() => {
                    context.commit('changeNewCarSuccessStatus', false)
                }, 1000)
            })
            .catch((err) => {
                context.commit('changeNewCarLoadingStatus', false)
                if (err.response && err.response.status === 422) {
                    context.commit('changeNewCarErrors', err.response.data)
                }
            })
    },
    setNewCarToDefault: ({commit}) => {
        commit('changeNewCarToDefault')
    },
    setNewCarErrorsToDefault: ({commit}) => {
        commit('changeNewCarErrorsToDefault')
    },
    setNewCarUser: ({commit}, newValue) => {
        commit('changeNewCarUser', newValue.id)
        commit('changeNewCarUserName', newValue.name)
    },
    setNewCarManager: ({commit}, newValue) => {
        commit('changeNewCarManager', newValue.id)
        commit('changeNewCarManagerName', newValue.name)
    },
    setNewCarAuction: ({commit}, newValue) => {
        commit('changeNewCarAuction', newValue)
    },
    setNewCarBrand: ({commit}, newValue) => {
        commit('changeNewCarBrand', newValue)
    },
    setNewCarChassis: ({commit}, newValue) => {
        commit('changeNewCarChassis', newValue)
    },
    setNewCarColor: ({commit}, newValue) => {
        commit('changeNewCarColor', newValue)
    },
    setNewCarDate: ({commit}, newValue) => {
        commit('changeNewCarDate', newValue)
    },
    setNewCarDisplacement: ({commit}, newValue) => {
        commit('changeNewCarDisplacement', newValue)
    },
    setNewCarEquipment: ({commit}, newValue) => {
        commit('changeNewCarEquipment', newValue)
    },
    setNewCarGrade: ({commit}, newValue) => {
        commit('changeNewCarGrade', newValue)
    },
    setNewCarLot: ({commit}, newValue) => {
        commit('changeNewCarLot', newValue)
    },
    setNewCarMileage: ({commit}, newValue) => {
        commit('changeNewCarMileage', newValue)
    },
    setNewCarModel: ({commit}, newValue) => {
        commit('changeNewCarModel', newValue)
    },
    setNewCarUsd: ({commit}, newValue) => {
        commit('changeNewCarUsd', newValue)
    },
    setNewCarResult: ({commit}, newValue) => {
        commit('changeNewCarResult', newValue)
    },
    setNewCarScore: ({commit}, newValue) => {
        commit('changeNewCarScore', newValue)
    },
    setNewCarTransmission: ({commit}, newValue) => {
        commit('changeNewCarTransmission', newValue)
    },
    setNewCarYear: ({commit}, newValue) => {
        commit('changeNewCarYear', newValue)
    },
    setNewCarUsers: ({commit}, newValue) => {
        commit('changeNewCarUsers', newValue)
    },
    downloadAllCarMediaFiles: ({commit}, carId) => {
        commit('changeNewCarLoadingStatus', true)
        apiCars
            .getCarMediaFilesZipRequest(carId)
            .then((response) => {
                const url = response.data.url
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', response.data.url.split('/').pop())
                document.body.appendChild(link)
                link.click()
                commit('changeNewCarLoadingStatus', false)
            })
            .catch(error => {
                console.log(error)
                commit('changeNewCarLoadingStatus', false)
            })
    },
    createShippingMultiproforma: ({commit}, data) => {
        commit('setDownloadStatus', true)
        return new Promise((resolve, reject) => {
            apiProformaInvoices
                .createShippingMultiproforma(data)
                .then((response) => {
                    commit('setMultiProformaId', response.data.id)
                    commit('setDownloadStatus', false)
                    resolve()
                })
                .catch(error => {
                    commit('setDownloadStatus', false)
                    console.log(error)
                    //commit('setErrors', JSON.parse(error.response.data))
                    reject()
                })
        });

    },
    fetchMultiProformaLatest: ({commit}) => {
        return apiProformaInvoices
            .multiProformaLatest()
            .then((response) => {
                if(Object.keys(response.data).length){
                    commit('setMultiProformaLatest', response.data)
                }
            })
    },
    updateMultiProformaLatest: ({commit}, data) => {
        commit('updateMultiProformaLatest', data)
    },
    setMultiProformaId: ({commit}, id) => {
        commit('setMultiProformaId', id)
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/car.js